/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Product,
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProductDataFrame
 */
export interface ProductDataFrame {
    /**
     * 
     * @type {number}
     * @memberof ProductDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof ProductDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof ProductDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<Product>}
     * @memberof ProductDataFrame
     */
    data: Array<Product>;
}

export function ProductDataFrameFromJSON(json: any): ProductDataFrame {
    return ProductDataFrameFromJSONTyped(json, false);
}

export function ProductDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(ProductFromJSON)),
    };
}

export function ProductDataFrameToJSON(value?: ProductDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(ProductToJSON)),
    };
}


